// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const PO_ST = {
  EmDigitacao: 'PO_ST1',
  EmAprovacao: 'PO_ST7',
  Aprovada: 'PO_ST2',
  Emitida: 'PO_ST9',
  FaturadaParcialmente: 'PO_ST11',
  EncerradaParcialmente: 'PO_ST10',
  Encerrada: 'PO_ST5',
  Reprovada: 'PO_ST8',
  Cancelada: 'PO_ST6',
  EmbarcadaTotal: 'PO_ST4',
  EmbarcadaParcial: 'PO_ST3',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    PO_ST1: 1,
    PO_ST7: 2,
    PO_ST2: 3,
    PO_ST9: 4,
    PO_ST11: 5,
    PO_ST10: 6,
    PO_ST5: 7,
    PO_ST8: 8,
    PO_ST6: 9
  }
}
